// extracted by mini-css-extract-plugin
export var bd = "br10-ub";
export var bigger = "br10-xb";
export var detail = "br10-wb";
export var downloadBar = "br10-tb";
export var footBottom = "br10-sb";
export var footBottomDesc = "br10-zb";
export var footerBottom = "br10-Bb";
export var ft = "br10-Ab";
export var logo = "br10-vb";
export var red = "br10-yb";